/**
 * @fileoverview Business-group and sector catalogs, plus sector-tree resolution.
 */

import { useEffect, useState } from "react";
import { getReferenceData } from "../../../logic/companyEdit";
import { resolveSectorClassificationFromTree } from "../../../utils/common";
import { fetchSectors } from "../../../logic/register/index.js";

export function useCorporateIdentityReferenceData({
  navigate,
  sectorEconomico,
  subSectorSCIAN,
  ramaSCIAN,
}) {
  const [businessGroups, setBusinessGroups] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [subSectors, setSubsectors] = useState([]);
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const [businessGroupsData, sectorsData] = await Promise.all([
        getReferenceData("businessGroups", navigate),
        fetchSectors(navigate),
      ]);
      setBusinessGroups(
        Array.isArray(businessGroupsData) ? businessGroupsData : [],
      );
      setSectors(Array.isArray(sectorsData) ? sectorsData : []);
    };
    fetchData();
  }, [navigate]);

  useEffect(() => {
    if (!sectors.length) {
      setSubsectors([]);
      setBranches([]);
      return;
    }

    const resolved = resolveSectorClassificationFromTree(
      sectors,
      sectorEconomico,
      subSectorSCIAN,
      ramaSCIAN,
    );

    setSubsectors(resolved.subSectors);
    setBranches(resolved.branches);
  }, [sectors, sectorEconomico, subSectorSCIAN, ramaSCIAN]);

  return {
    businessGroups,
    sectors,
    subSectors,
    branches,
    setSubsectors,
    setBranches,
  };
}
